"use strict";

exports.__esModule = true;
exports.LayoutTemplateCollection = LayoutTemplateCollection;
var _react = _interopRequireDefault(require("react"));
var _API = require("../../API");
var _excluded = ["children"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
/**
 * Provides access to layoutTemplates via a render prop.
 */
function LayoutTemplateCollection(_ref) {
  var children = _ref.children,
    extra = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_API.Collection, _extends({
    baseURL: "/api/v3/ui-config/reports",
    itemBaseURL: "/api/v3/ui-config/reports/:id"
  }, extra), children);
}